export enum LibraryStructureTypeEnum {
    ARTICLE_ABSTRACT = 'ARTICLE_ABSTRACT',
    CONTENT_BLOCK = 'CONTENT_BLOCK',
    CONTENT_PAGE = 'CONTENT_PAGE'
}
